import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import GoContainer from './GoContainer';
import '../NYCFleets.css';

const AutzuGo = () => (
  <Fragment>
    <Helmet>
      <title>Go | Autzu</title>
      <meta
        name="description"
        content="Join Autzu and start Drivesharing! From as low as $7/hr, you can rent an Autzu TLC-approved vehicle to drive and earn with Via in NYC . There are no upfront payments or term commitments. Sign up today!"
      />
    </Helmet>
    <GoContainer />
  </Fragment>
);

export default AutzuGo;



// WEBPACK FOOTER //
// ./src/components/Static/NYCFleets/AutzuGo/index.js